module.exports = __webpack_public_path__ + "img/gear.032cec57.svg";